<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-card class="backClass" header="Received">
        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">
            Active Backlog
          </h5>
          <!-- <b-button
              @click="detailView"
              class="btn-outline ml-3"
              variant="outline-primary"
              right
            >
              Details
            </b-button> -->
          <div class="card-header-actions">
            <b-button
              @click="toggleFullScreen"
              style="height: 26px; width: 26px"
              class="float-right"
              variant="transparent p-0"
              right
            >
              <i style="color: #20a8d8;" class="icon-frame"></i>
            </b-button>
            <b-button
              class="btn"
              style="height: 26px; width: 26px"
              variant="transparent p-0"
              attr="pdf"
              @click="downloadPDF()"
            >
              <i
                class="fa fa-file-pdf-o"
                style="color: rgb(32, 168, 216);"
                aria-hidden="true"
              ></i>
            </b-button>
          </div>
        </div>
        <div style="margin-top: 30px" class="chart-wrapper">
          <div
            style="height: 400px; padding-top: 150px"
            v-if="loadingData"
            class="loading"
          >
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <!-- <div slot="footer">
          <b-button
            :disabled="!showAll"
            class="btn-outline"
            variant="outline-primary"
            left
            @click="showAll = false, fetchData()"
          >Top 10</b-button>

          <b-button
            :disabled="showAll"
            class="btn-outline float-right"
            variant="outline-primary"
            right
            @click="showAll = true, fetchData()"
          >All Data</b-button>
        </div> -->
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../router";
import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
exporting(Highcharts);
export default {
  name: "ActiveBacklog-Column",
  components: {
    router,
    highcharts: Chart,
    Highcharts
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity"],
  data: function() {
    return {
      fullscreen: false,
      city: "",
      loadingData: false,
      showAll: false,
      dateTo: "",
      shippedLocation: "",
      shippedProductGroup: "",
      productModel: "",
      locationsIds: "",
      chartOptions: {
        chart: {
          type: "column",
          backgroundColor: "transparent",
          events: {
            drilldown: ({ point }) => {
              this.shippedProductGroup = point.name;
            },
            drillup: ({ e }) => {
              this.shippedProductGroup = "";
            }
          }
        },
        exporting: {
          enabled: true
        },
        title: {
          text: "",
          style: {
            color: "white",
            display: ""
          }
        },
        subtitle: {
          text: "Click the bars to view by product group",
          style: {
            color: "white",
            display: ""
          }
        },
        xAxis: {
          type: "category",
          labels: {
            style: {
              color: "white"
            }
          }
        },
        yAxis: {
          title: {
            text: "Percentage Of Total"
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false,
              format: "{point.name}: {point.y:.1f}%",
              color: "white",
              style: {
                textOutline: false
              }
            },
            point: {
              events: {
                click: ({ point }) => {
                  if (point.name) {
                    console.log(point.name);
                    this.productModel = point.name;
                    if (this.locParam == 1) {
                      router.push(
                        "/base/Tables/?productGroup=" +
                          this.shippedLocation +
                          "&productGroup=" +
                          this.shippedProductGroup +
                          "&productModel=" +
                          this.productModel +
                          "&type=backlog" +
                          "&clients=" +
                          this.locationsIds
                      );
                    } else {
                      router.push(
                        "/base/Tables/?location=" +
                          this.city +
                          "&productGroup=" +
                          this.shippedProductGroup +
                          "&productModel=" +
                          this.productModel +
                          "&type=backlog" +
                          "&clients=" +
                          this.locationsIds
                      );
                    }
                  }
                }
              }
            }
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            textDecoration: "none",
            color: "white"
          },
          activeDataLabelStyle: {
            color: "white"
          }
        },
        series: [
          {
            name: "Product Groups",
            colorByPoint: true,
            data: null
          }
        ]
      }
    };
  },
  methods: {
    detailView() {
      this.$emit("detailView");
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        chartType: "backlog",
        client: this.idCity
      };
      this.$http.get("api/fns/charts/chart_city.php", { params }).then(
        res => {
          if (!this.showAll) {
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.ProductGroupTotal) > parseFloat(b.ProductGroupTotal)
                ? -1
                : 1
            );

            let smp = res.data.dnData;

            smp.forEach((value, index) => {
              value.data.sort((a, b) =>
                parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
              );
            });

            let newArr = tmp.slice(0, 10);

            this.chartOptions.series[0].data = newArr;
            this.chartOptions.drilldown.series = smp;
          } else {
            let smp = res.data.dnData;

            smp.forEach((value, index) => {
              value.data.sort((a, b) =>
                parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
              );
            });
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.ProductGroupTotal) > parseFloat(b.ProductGroupTotal)
                ? -1
                : 1
            );

            this.chartOptions.series[0].data = tmp;
            this.chartOptions.drilldown.series = smp;
          }

          // Getting total amount wihtout response
          var seriesData = this.chartOptions.series;
          var pointSum = 0;
          console.log(seriesData);
          seriesData.forEach(function(point) {
            var datasValue = point.data;
            datasValue.forEach(function(value) {
              pointSum += parseInt(value.ProductGroupTotal);
            });
          });

          this.chartOptions.title.text = "Total units: " + pointSum;

          this.loadingData = false;
          setTimeout(() => {
            this.changeHeight();
          });
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    downloadPDF() {
      if (this.locParam == 1) {
        this.$refs.backRef.chart.options.title.text =
          "Active Backlog | " + this.dateTo + " " + this.shippedLocation;
        this.$refs.backRef.chart.options.title.style.color = "black";
      } else {
        this.$refs.backRef.chart.options.title.text =
          "Active Backlog | " + this.dateTo + " " + this.nameCity;
        this.$refs.backRef.chart.options.title.style.color = "black";
      }

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });

      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename: "ActiveBacklog-" + this.dateTo
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
    }
  },
  mounted() {
    if (!localStorage.getItem("fns_user")) {
      router.push("/pages/login/");
    }
    this.dateTo = new Date().toJSON().slice(0, 10);
    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
      this.city = this.nameCity + "%287%29";
    }

    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-exporting-group {
  display: none !important;
}
</style>
